export default __webpack_public_path__ + "static/media/animation-arrow13.2bf9d64e.gif";